import React from 'react'
import "../articles.css"

import rotor from "../../../../assets/images/articles/rotor.jpg"
import { Byline, Published } from "../.."
import Carbonhistory from "../../../../assets/images/articles/Carbonhistory.jpeg"


export default function Article7Doc() {


  return (
    <div className='emas__articles'>
      <div className='emas__articles-container'>
          <img className="emas__articles-container_headImage" src={rotor} alt="rotor"></img>
          <div className='emas__articles-container_photo'>
            <i >Photo by Peter de Vink: https://www.pexels.com/photo/white-windmill-851004/</i>
          </div>
          <h1>Carbon emissions tracker</h1>
          <div className='emas__articles-container_publish'>
            <p></p>
          </div>
          <div className='emas__articles-container_body'>
            <p>Updated April 2025</p>
            <p>The following chart tracks the profile of carbon emissions from the Wholesale Electricity Market for each year since 2020. As can be seen in the chart, there has not been any discernible improvement in carbon emissions. Emissions for each year tracks emissions from the previous years with only minor variation. </p>
        </div>    
          <div className='emas__articles-container_photo'>
          <img className="emas__articles-container_headImage" src={Carbonhistory} alt="Carbonhistory"></img>
          </div>   
          <Published />
      </div>
  </div>
  )
}
